<div class="field-type-clients-selector__container">
  @if (fieldTypeClientsSelector.findOrganizations) {
    <div class="field-type-clients-selector__result-search-container">
      <span class="field-type-clients-selector__result-search-text"
        [afTranslate]="'result-search.search-result'">
        _Resultados de la búsqueda
      </span>
    </div>
  } @else {
    <div class="field-type-clients-selector__alphabet-container">
      <div class="field-type-clients-selector__inner-alphabet-container">
        @for (letter of fieldTypeClientsSelector.alphabetList; track $index) {
          <button
            (click)="chooseLetter(letter)"
            [disabled]="letter.itemsCount === 0"
            [ngClass]="{
              'common-tab__tertiary common-tab__tertiary--alphabet !px-xs': $first,
              'common-tab__tertiary--selected': $first && letter.selected,
              'common-tab__alphabet': !$first,
              'common-tab__alphabet--selected': !$first && letter.selected,
              'common-tab__alphabet--disabled': !$first && letter.itemsCount == 0
            }">
            @if ($first) {
              <p class="common-tab__tertiary-button-text">
                {{letter.text}}
              </p>
            } @else {
              {{letter.text}}
            }
          </button>
        }
      </div>
    </div>
  }
  <div class="field-type-clients-selector__search-create-container">
    <div class="common-search__container w-full">
      <div class="common-search__container-tonal"
        [ngClass]="{'common-search__container-tonal--error': fieldTypeClientsSelector.errorInSearch}">
        <div class="common-search__container-input-text">
          <input
            (keydown.enter)="changeList($event)"
            type="search"
            class="common-search__input-text"
            [(ngModel)]="fieldTypeClientsSelector.searchClient"
            placeholder="{{'common.search-item' | afTranslate}}"
          />
        </div>
        <div class="common-search__block-button-search">
          @if (fieldTypeClientsSelector.searchClient) {
            <button
              type="button"
              class="common-button__icon-xs-noborder"
              (click)="deleteSearch()">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          }
          <div
            class="h-[22px]"
            [ngClass]="{
              'common-divider__vertical-main-1000': fieldTypeClientsSelector.findOrganizations,
              'common-divider__vertical-grey-400': !fieldTypeClientsSelector.findOrganizations
            }">
          </div>
          <button
            type="button"
            (click)="findSearch()"
            class="common-button__icon-sm-noborder">
            <i class="lf-icon-search common-icon__md">
            </i>
          </button>
        </div>
      </div>
    </div>
    <button
      class="common-button__icon-md-border"
      type="button"
      (click)="addOrganization()"
      [disabled]="!permissions.canCreateOnlyAffiliates && !permissions.canCreateClients">
      <i class="lf-icon-sum common-icon__md">
      </i>
    </button>
    @if (fieldTypeClientsSelector.errorInSearch) {
      <div class="common-search__container-error col-span-2">
        <span afTranslate="common.required-3-characters">
          _Es necesario introducir al menos 3 caracteres
        </span>
      </div>
    }
  </div>
  <div class="w-full">
    <div class="field-type-clients-selector__container-list">
      @if (fieldTypeClientsSelector.noOrganizations && fieldTypeClientsSelector.findOrganizations) {
        <div class="field-type-clients-selector__empty-container">
          <span class="common-empty-state__message-container"
            [afTranslate]="'new-evaluation.no-results-for-search'">
            _No hay resultados que coincidan con tu búsqueda
          </span>
        </div>
      }
      @if (fieldTypeClientsSelector.noOrganizations && !fieldTypeClientsSelector.findOrganizations) {
        <div class="field-type-clients-selector__empty-container">
          <div class="field-type-clients-selector__empty-organizations-container">
            <i class="field-type-clients-selector__empty-organizations-icon lf-icon-build common-icon__xl">
            </i>
            <p
              class="field-type-clients-selector__empty-organizations-text"
              afTranslate="new-evaluation.no-organizations-text">
              _No se han registrado organizaciones
            </p>
            <p
              class="field-type-clients-selector__empty-organizations-subtext"
              afTranslate="new-evaluation.no-organizations-subtext">
              _Pulsa el botón “Añadir” para crear una nueva
            </p>
          </div>
        </div>
      }
      @if(!fieldTypeClientsSelector.errorInSearch && !fieldTypeClientsSelector.noOrganizations){
        <div class="common-avatar-list__container">
          @for (client of fieldTypeClientsSelector.filterList | afOrderBy: fieldTypeClientsSelector.byword:false; track client.clientId) {
            <button class="common-avatar-list__button-item"
              [ngClass]="{
                'common-avatar-list__button-item--selected': client.selected,
                'common-avatar-list__button-item--disabled': !client.parentName && client.disabled,
                'common-avatar-list__button-item--no-hover': !client.parentName && (client.blocked || client.disabled)
              }"
              (click)="selectClient(client)"
              [disabled]="!client.parentName && (client.disabled || client.blocked)">
              <div [ngClass]="client.logo?'common-avatar-container__xl-logo':'common-avatar-container__xl'">
                @if (client.logo) {
                  <img alt="Client logo"
                    [src]="client.logo"
                    draggable="false"
                    loading="lazy" />
                } @else {
                  <span class="avatar-text common-avatar-size__xl">
                    {{client.initials}}
                  </span>
                }
              </div>
              <div class="common-avatar-list__text-container">
                <span class="common-avatar-list__name"
                  [ngClass]="{ 'common-avatar-list__name--blocked': client.blocked }">
                  {{client.parentName?client.parentName:client.nameSelected}}
                </span>
                @if (client.selected && client.parentName) {
                  <div class="common-avatar-list__filials-container">
                    <span class="common-avatar-list__filial">
                      {{client.nameSelected}}
                    </span>
                  </div>
                }@else if (client.children.length && !client.selected) {
                  <div #filialsContainer>
                    <div class="common-avatar-list__filials-container">
                      <button class="common-button__link"
                        (click)="toggleDropdown($event, filialsDropdown, filialsContainer)">
                        <span class="common-button__link-text"
                          [afTranslate]="'new-evaluation.filials'">
                        </span>
                      </button>
                    </div>
                    <p-overlayPanel #filialsDropdown
                      styleClass="common-dropdown-overlay__container !mt-[2px]">
                      <ng-template pTemplate="content">
                        <div class="common-dropdown__items-container">
                          @for (child of client.children | orderBy: 'name'; track $index) {
                            <button class="common-dropdown-list__si-button-cascade"
                              [ngClass]="{ 'common-dropdown-list__si-button-cascade--disabled-red': client.blocked }"
                              [disabled]="client.disabled || client.blocked"
                              (click)="selectChild($event, child)">
                              <span [ngClass]="child.open? 'common-dropdown-list__si-button-inner-border' : 'common-dropdown-list__si-button-inner'">
                                @if (child.children.length) {
                                  <i class="common-icon__sm"
                                    [ngClass]="child.open ? 'lf-icon-angle-up' : 'lf-icon-angle-down'"
                                    (click)="openChild($event, child)">
                                  </i>
                                }
                                <span-tooltip class="common-dropdown-list__si-text-container"
                                  [ngClass]="{'common-avatar-list__filial--list-blocked': client.blocked }"
                                  [text]="child.name">
                                </span-tooltip>
                              </span>
                            </button>
                            @if (child.children.length && child.open) {
                              <filials
                                class="w-full"
                                [child]="child"
                                [level]="0"
                                (openChildEmit)="openChildOn($event)"
                                (selectChildEmit)="selectChildOn($event)" >
                              </filials>
                            }
                          }
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                }
              </div>
            </button>
          }
        </div>
      }
      @if (fieldTypeClientsSelector.selectedLetter.itemsCount > fieldTypeClientsSelector.selectedLetter.results.length) {
        <div class="common-more-organizations flex justify-center py-[1px]">
          <button
            (click)="getMore()"
            class="common-button__expand-toned"
            type="button">
            <i class="lf-icon-angle-down common-icon__md">
            </i>
            <span
              [afTranslate]="'new-evaluation.see-more-organizations'"
              class="common-button__expand-label-text">
              _Ver más organizaciones
            </span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
